import route from 'ziggy';
import { Ziggy } from '@/ziggy';

const _route = (path, args = {}) => route(path, args, null, Ziggy);

export default _route;
